(function () {

  function changeLogNotification($rootScope, $timeout) {
    return {
      restrict: 'E',
      scope: false,
      templateUrl: 'app/directives/changeLogNotificationDirective/changeLogNotification.template.html',
      link: function (scope, element, attrs) {

        scope.notificationEnabled = false;
        scope.shake = false;
        scope.showNotification = false;

        scope.$watch(function () {
          return $rootScope.currentUser;
        }, function () {
          if ($rootScope.currentUser) {
            scope.userFirstName = $rootScope.currentUser.info._embedded.user.name.split(' ')[0];
            initTimeout();
          }
        }, true);

        scope.openNotificationDialog = function () {
          scope.notificationEnabled = false;
          $timeout(function () {
            scope.showNotification = true;
          }, 300);
        };

        scope.hideChangeLogNotification = function () {
          scope.showNotification = false;
          $rootScope.currentUser.hideChangeLogNotification();
        };

        let timer = 15000;

        function initTimeout() {
          $timeout(function () {
            if ($rootScope.currentUser.showChangeLogNotification()) {
              scope.notificationEnabled = true;
            }
          }, 3000);
        }

        function animationTimer() {
          $timeout(function () {
            if (!scope.shake) {
              scope.shake = true;
              timer = 820;
              animationTimer();
            } else {
              scope.shake = false;
              timer = 15000;
              animationTimer();
            }
          }, timer);
        }

        (function () {
          animationTimer();
        })();

      }
    };
  }

  changeLogNotification.$inject = ['$rootScope', '$timeout'];

  angular
    .module('printix-admin')
    .directive('changeLogNotification', changeLogNotification);

})();
